var _excluded = ["className", "children", "reverse", "align", "verticalAlign", "collapsedV", "collapsedH", "borderedRows", "spread", "gray", "borderTop", "borderBottom", "borderLeft", "borderRight", "utils"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { GridColumn } from './components';
import StyledGrid from './grid.styles';
import { StyledCacheWrapper } from '../../styles';
var gridProps = {
  /** Add custom CSS classes to component. */
  className: PropTypes.string,
  /** Grid Content */
  children: PropTypes.node,
  /** Reverse content of the row. */
  reverse: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  /** Sets the horizontal alignment of the columns. */
  align: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object]),
  /** Sets the vertical alignment of the columns. */
  verticalAlign: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object]),
  /** Removes the Grid's vertical margins when true. */
  collapsedV: PropTypes.bool,
  /** Removes the Grid's horizontal margins when true. */
  collapsedH: PropTypes.bool,
  /** Adds bottom borders to child Grid.Column components. */
  borderedRows: PropTypes.bool,
  /** Adds left border to Grid. */
  borderLeft: PropTypes.bool,
  /** Adds right border to Grid. */
  borderRight: PropTypes.bool,
  /** Determines the spread of around or between (flex) when in use. */
  spread: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object]),
  /** Sets the background for the Grid to gray. */
  gray: PropTypes.bool,
  /** Applies the top border to the Grid. */
  borderTop: PropTypes.bool,
  /** Applies the bottom border to the Grid. */
  borderBottom: PropTypes.bool,
  /** Add utility props for styling */
  utils: PropTypes.object
};
var gridPropsDefault = {
  className: '',
  children: /*#__PURE__*/React.createElement("div", null),
  reverse: false,
  align: false,
  verticalAlign: false,
  collapsedV: false,
  collapsedH: false,
  borderedRows: false,
  spread: false,
  gray: false,
  borderBottom: false,
  borderTop: false,
  borderLeft: false,
  borderRight: false,
  utils: {}
};

/**
 * @ignore @description
 * ## Grid Component
 * A powerful mobile-first grid system for building layouts of all shapes and sizes. It’s based on a 12 column layout and has multiple tiers, one for each media breakpoint.
 *
 * @ignore @see Mesh: [Grid Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/scaffolding-grid--default)
 *
 * @ignore @example
 * ```jsx
 * import { Grid } from 'mesh-component-library';
 *
 * <Grid {...props}>
 *  {children}
 * </Grid>
 * ```
 */

var Grid = function Grid(props) {
  var className = props.className,
    children = props.children,
    reverse = props.reverse,
    align = props.align,
    verticalAlign = props.verticalAlign,
    collapsedV = props.collapsedV,
    collapsedH = props.collapsedH,
    borderedRows = props.borderedRows,
    spread = props.spread,
    gray = props.gray,
    borderTop = props.borderTop,
    borderBottom = props.borderBottom,
    borderLeft = props.borderLeft,
    borderRight = props.borderRight,
    utils = props.utils,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(StyledCacheWrapper, null, /*#__PURE__*/React.createElement(StyledGrid, _extends({}, other, {
    alignedHorizontal: align,
    alignedVertical: verticalAlign,
    borderBottom: borderBottom,
    borderLeft: borderLeft,
    borderRight: borderRight,
    borderTop: borderTop,
    className: className,
    hasBorderedRows: borderedRows,
    isCollapsedH: collapsedH,
    isCollapsedV: collapsedV,
    isGray: gray,
    isReverse: reverse,
    spread: spread,
    utils: utils
  }), children));
};

/**
 * ## Grid Column
 * @see Mesh: [Grid Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/scaffolding-grid-subcomponents-grid-column--default)
 * @example
 * ```jsx
 * import { Grid } from 'mesh-component-library';
 *
 * <Grid.Column {...props}>
 * </Grid.Column>
 * ```
 */

Grid.Column = GridColumn;
Grid.propTypes = gridProps;
Grid.defaultProps = gridPropsDefault;
export default Grid;